export default "__VITE_ASSET__KceP9wfd__"